export default () => {

  const $alphaScroll = $('.alpha-scroll');

  if ($alphaScroll.length) {

    const $button = $('.alpha-scroll-nav-letter'),
          $scrollableDiv = $('.alpha-scroll-content');

    $button.on('click', (e) => {

      const letter = $(e.currentTarget).data('letter'),
            section = document.querySelector(`.alpha-scroll-section[data-section="${letter}"]`) || '',
            topPos = section.offsetTop;

      $button.removeClass('-active');
      $(e.currentTarget).addClass('-active');

      if (section) {
        $scrollableDiv.stop().animate({
          scrollTop: topPos
        }, 500);
      }

    });

  }

};
